import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "src/styles/slick.css";
import "src/styles/slick-theme.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import AsDetailInfo from "src/components/as/AsDetailInfo";
import SelectVender from "src/components/as/SelectVender";
import BottomModal, { RefProps } from "src/components/common/BottomModal";
import SelectCompanyItem from "src/components/filter/SelectCompanyItem";
import List from "src/components/common/List";
import CommentItem from "src/components/as/CommentItem";
import CommentInput from "src/components/as/CommentInput";
import StopAsItem from "src/components/filter/StopAsItem";
import AsProcessItem from "src/components/filter/AsProcessItem";
import SVG from "src/utils/SVG";
import IconButton from "src/components/common/IconButton";
import styled from "styled-components";
import { useAppSelector } from "src/store/actions/action";
import { shallowEqual, useDispatch } from "react-redux";
import { useAsDetailQuery, useCancelAsMutation, useDeleteAsToDbMutation, useUpdateAsAsignCompanyMutation, useUpdateAsStartMutation } from "src/api/asAPI";
import { getPathValue } from "src/utils/queryStringUtil";
import ImageModal from "src/components/common/ImageModal";
import Modal from "src/components/common/Modal";
import { isEmpty } from "lodash";
import queryString from "query-string";
import { setOnFocusReduce, setWriteNameReduce } from "src/store/reducers/asDetailReduce";
import ErrorParser from "src/utils/jsonParser";
import VideoBox from "src/components/common/VideoBox";
import CommentInputV2 from "../../components/as/CommentInputV2";
import { BLOCKED_USER, SOS_AS_LIST, sosListSet } from "../../utils/sosFunc";

const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;

const asDetail = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParser = queryString.parse(search);
  const rnData = queryParser["rn"];
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);

  const index: any = getPathValue();

  const dispatch = useDispatch();

  const [init, setInit] = useState({
    comment: [],
    render: false,
    apiSkip: true,
    check: "N",
  });
  const { comment, render, apiSkip, check } = init;

  const [freeCheckValue, setFreeCheckValue] = useState<boolean>(false);
  const [selectedCom, setSelectedCom]: any = useState([]);

  // API 영역
  const asDetail = useAsDetailQuery(index, { skip: apiSkip });

  // AS 진행
  const [updateStart, { isLoading: isUpdating2 }] = useUpdateAsStartMutation();
  // AS 업체 지정
  const [updateCompanySelectComfirm, { isLoading: isUpdating3, isError: isErrorSelectCompany, error: selectCampanyError }] = useUpdateAsAsignCompanyMutation();
  // AS 취소
  const [asCancel, { isLoading: isUpdatingAsCancel, isSuccess: isSuccessAsCancel, isError: isErrorAsCancel, error: asCancelError }] = useCancelAsMutation();
  // AS 삭제
  const [asDelete, { isLoading: isUpdatingAsDelete, isSuccess: isSuccessAsDelete, isError: isErrorAsDelete, error: asDeleteError }] = useDeleteAsToDbMutation();

  // 삭제된 as건 링크이동 처리
  const deletedModalRef = React.useRef<RefProps>(null);

  // hook 영역
  useEffect(() => {
    setInit({
      ...init,
      apiSkip: false,
    });
  }, []);

  useEffect(() => {
    if (asDetail.isSuccess) {
      window.scrollTo({ top: 1 });
      setSelectedCom([asDetail.data.company_id]);
      if (asDetail.data.free_yn === "Y") {
        setFreeCheckValue(true);
        setInit({
          ...init,
          check: "Y",
        });
      } else {
        setFreeCheckValue(false);
        setInit({
          ...init,
          check: "N",
        });
      }
    }
    if (asDetail.isError) {
      if (deletedModalRef.current) deletedModalRef.current.modalOpen();
    }
  }, [asDetail]);

  useEffect(() => {
    if (isSuccessAsCancel) {
      navigate("/as-list");
    }
    if (isErrorAsCancel) {
      const message = ErrorParser(asCancelError);
      alert(message);
    }
  }, [isSuccessAsCancel, isErrorAsCancel]);

  useEffect(() => {
    if (isSuccessAsDelete) {
      alert("A/S가 삭제되었습니다.");
      navigate("/as-list");
    }
    if (isErrorAsDelete) {
      const message = ErrorParser(asDeleteError);
      alert(message);
    }
  }, [isSuccessAsDelete, isErrorAsDelete]);

  useEffect(() => {
    if (isErrorSelectCompany) {
      const message = ErrorParser(selectCampanyError);
      alert(message);
    }
  }, [isErrorSelectCompany]);

  // 클릭 이벤트 영역
  const confirmDeleted = () => {
    if (deletedModalRef.current) deletedModalRef.current.modalClose();
    navigate("/as-list/");
  };

  const asUpdateStart = async () => {
    await updateStart({ as_idx: index });
    asDetail.refetch();
  };

  const freeCheck = (check: boolean) => {
    // const className = e.currentTarget.parentElement?.className;
    setFreeCheckValue(!check);
    let flag = "";
    if (check) {
      flag = "N";
    } else {
      flag = "Y";
    }
    setInit({
      ...init,
      check: flag,
    });
  };

  const selectCompanyComfirm = async (e: React.MouseEvent) => {
    if (isEmpty(selectedCom)) {
      alert("업체를 선택해주세요");
      return;
    }
    const params = {
      as_idx: index,
      company_ids: selectedCom,
      free_yn: check,
    };
    if (venderModalRef.current) venderModalRef.current.modalClose();
    await updateCompanySelectComfirm(params);
    asDetail.refetch();
  };

  const companyChange = () => {
    openVenderSelect();
  };

  const asCancelBtn = async () => {
    await asCancel(index);
    if (stopModalRef.current) stopModalRef.current.modalClose();
  };

  const estimateRegisterUpdate = () => {
    // navigate("/estimate-register/" + index);
    location.replace("/estimate-register/" + index);
    // history.replacestate({}, "", "/estimate-register/" + index);
  };

  // const selectCompanyItemToFunc = (id: string, name: string) => {
  const selectCompanyItemToFunc = (comId: any, comName: any) => {
    setSelectedCom(comId);
  };

  // +++++++++++++++++++++++++++++++++++ 퍼블리셔 영역 +++++++++++++++++++++++++++++++++++
  const venderModalRef = React.useRef<RefProps>(null);
  const imageModalRef = React.useRef<RefProps>(null);
  const cmtImgModalRef = React.useRef<RefProps>(null);
  const stopModalRef = React.useRef<RefProps>(null);
  const processModalRef = React.useRef<RefProps>(null);

  const openVenderSelect = () => {
    if (venderModalRef.current) venderModalRef.current.modalOpen();
  };

  const openImageModal = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (imageModalRef.current) imageModalRef.current.modalOpen();
  };

  const openStopModal = () => {
    if (stopModalRef.current) stopModalRef.current.modalOpen();
  };

  const openProcessModal = () => {
    if (processModalRef.current) processModalRef.current.modalOpen();
  };

  // 클릭 이벤트

  const asProcessBtn = (code: string) => {
    if (code === "Q") {
      if (confirm("AS를 취소하시겠습니까?")) {
        if (processModalRef.current) processModalRef.current.modalClose();
        asCancel(index);
      }
    } else if (code === "U") {
      // 매장 수정하기
      if (processModalRef.current) processModalRef.current.modalClose();
      navigate("/as-register/" + index);
    } else if (code === "D") {
      // 매장에서 AS 삭제하기
      if (confirm("AS를 삭제하시겠습니까?")) {
        if (processModalRef.current) processModalRef.current.modalClose();
        asDelete(index);
      }
    } else if (code === "E") {
      if (confirm("AS를 신고하시겠습니까?")) {
        sosListSet(SOS_AS_LIST, index);
        if (processModalRef.current) processModalRef.current.modalClose();
        navigate("/as-list", { replace: true });
      }
    } else if (code === "F") {
      if (confirm("해당 사용자를 차단하시겠습니까?")) {
        sosListSet(BLOCKED_USER, asDetail.data.store_id);
        if (processModalRef.current) processModalRef.current.modalClose();
        navigate("/as-list", { replace: true });
      }
    }
  };

  // 푸시 메시지로 들어왔을경우에 대한 history back
  const backClick = () => {
    if (!isEmpty(rnData)) {
      navigate("/as-list");
    } else {
      navigate(-1);
    }
  };

  // 뒤로가기를 할때 reducer 초기화
  useEffect(() => {
    // history.pushState(null, "", location.href);
    window.onpopstate = function (event) {
      // 사진 클릭 후 뒤로가기시 body 스크롤 풀기
      document.body.style.overflow = "unset";
      dispatch(setOnFocusReduce(false));
      dispatch(setWriteNameReduce(["", ""]));
    };
  }, []);

  const progressBtn = () => {
    // =========================================== 본사 로직 ===========================================
    if (userInfo.user_type === "E") {
      if (asDetail.isSuccess) {
        if (asDetail.data.progress_value === "20") {
          if (asDetail.data.delete_yn !== "Y") {
            return (
              <ButtonBox>
                <Button variant="outlined" br="round" color="secondary" onClick={openStopModal}>
                  진행 안함
                </Button>
                <Button variant="contained" br="round" onClick={() => asUpdateStart()}>
                  A/S 진행
                </Button>
              </ButtonBox>
            );
          }
        } else if (asDetail.data.progress_value === "40") {
          if (asDetail.data.delete_yn !== "Y") {
            return (
              <>
                <ButtonBox>
                  <Button variant="contained" br="round" onClick={openVenderSelect}>
                    A/S 업체 배정
                  </Button>
                </ButtonBox>
                <BottomModal
                  ref={venderModalRef}
                  modalTitle="업체 선택"
                  checkBox="무상"
                  footerBtn="선택하기"
                  checked={freeCheckValue}
                  onChange={(children) => freeCheck(children)}
                  onClick2={(e) => selectCompanyComfirm(e)}
                >
                  <SelectCompanyItem multiSelect={true} selectedCom={asDetail.data.company_id} selectCompanyItemToFunc={selectCompanyItemToFunc} />
                </BottomModal>
              </>
            );
          }
        } else if (asDetail.data.progress_value >= 60) {
          return (
            <>
              {asDetail.data.delete_yn !== "Y" && (
                <BottomModal
                  ref={venderModalRef}
                  modalTitle="업체 선택"
                  checkBox="무상"
                  footerBtn="선택하기"
                  checked={freeCheckValue}
                  onChange={(children) => freeCheck(children)}
                  onClick2={(e) => selectCompanyComfirm(e)}
                >
                  <SelectCompanyItem multiSelect={true} selectedCom={asDetail.data.company_id} selectCompanyItemToFunc={selectCompanyItemToFunc} />
                </BottomModal>
              )}
              <SelectVender index={index} onClick={() => companyChange()} />
            </>
          );
        }
      }
    }
    // =========================================== 매장 로직 ===========================================
    else if (userInfo.user_type === "S") {
      if (asDetail.isSuccess) {
        if (asDetail.data.progress_value >= 60) {
          return <SelectVender index={index} onClick={() => companyChange()} />;
        }
      }
    }
    // =========================================== 업체 로직 ===========================================
    else if (userInfo.user_type === "M") {
      if (asDetail.isSuccess) {
        // if (asDetail.data.progress === "AS_0") {
        //   return;
        // }
        {
          /* 진행 상황 보여주는 곳 */
        }
        return (
          <>
            <SelectVender index={index} />
          </>
        );
        // if (asDetail.data.progress_value >= 60) {
        //   if (asDetail.data.delete_yn !== "Y") {
        //     if (asDetail.data.es_approval_code === "EAC_10") {
        //       return (
        //         <>
        //           <ButtonBox>
        //             {asDetail.data.free_yn === "Y" ? (
        //               <Button variant="outlined" br="round" color="secondary">
        //                 <Link to={"/estimate-register/" + index}>무상 견적서 등록</Link>
        //               </Button>
        //             ) : (
        //               <Button variant="contained" br="round">
        //                 <Link to={"/estimate-register/" + index}>견적서 등록</Link>
        //               </Button>
        //             )}
        //           </ButtonBox>
        //         </>
        //       );
        //     } else if (asDetail.data.es_approval_code === "EAC_20") {
        //       return (
        //         <>
        //           <ButtonBox>
        //             <Button variant="outlined" br="round" color="secondary" onClick={() => estimateRegisterUpdate()}>
        //               <Link to="">견적서 재등록</Link>
        //             </Button>
        //           </ButtonBox>
        //         </>
        //       );
        //     }
        //   }
        //   return (
        //     <>
        //       {/* 진행 상황 보여주는 곳 */}
        //       <SelectVender index={index} />
        //     </>
        //   );
        // }
      }
    }
  };

  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const slider1 = React.useRef(null);
  const slider2 = React.useRef(null);

  useEffect(() => {
    if (slider1.current !== null && slider2.current !== null) {
      setNav1(slider1.current);
      setNav2(slider2.current);
    }
  }, [asDetail.isSuccess]);

  const settingsNav1 = {
    ref: slider1,
    asNavFor: nav2,
    useTransform: false,
    dots: true,
    infinite: false,
    speed: 100,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    cssEase: "ease-out",
  };

  const settingsNav2 = {
    ref: slider2,
    asNavFor: nav1,
    useTransform: false,
    dots: true,
    infinite: false,
    speed: 100,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    cssEase: "ease-out",
  };

  const settings = {
    useTransform: false,
    dots: true,
    infinite: false,
    speed: 100,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    cssEase: "ease-out",
  };

  const [cmtView, setCmtView] = useState({
    cmtType: "parent",
    cmtIdx: 0,
    cmtchildIdx: 0,
    imgIdx: 0,
  });
  const [imageSlider, setImageSlider] = useState<Slider | null>(null);
  const [changeSlide, setChangeSlide] = useState(false);

  const clickCmtImages = (e: React.MouseEvent<HTMLLIElement>) => {
    setCmtView({
      ...cmtView,
      cmtType: String(e.currentTarget.dataset.cmtType),
      cmtIdx: Number(e.currentTarget.dataset.cmtIdx),
      cmtchildIdx: Number(e.currentTarget.dataset.cmtchildIdx),
      imgIdx: Number(e.currentTarget.dataset.imgIdx),
    });
    imageSlider?.slickGoTo(Number(e.currentTarget.dataset.imgIdx));
    setChangeSlide(true);
  };

  useEffect(() => {
    if (changeSlide) {
      if (cmtImgModalRef.current) cmtImgModalRef.current.modalOpen();
    }
    setChangeSlide(false);
  }, [changeSlide]);

  // 애니메이션 효과로 인한 추가 작업
  if (isEmpty(index) || index === null || index === "") {
    return <div></div>;
  }

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => backClick()}>
            {asDetail.isSuccess && asDetail.data.store_name}
          </Button>
          {asDetail.isSuccess && asDetail.data.new_yn === "Y" ? <NewStore>N</NewStore> : ""}
        </div>
        <div className="btn-box">
          <IconButton btnName="프로필페이지" className="information" onClick={() => navigate("/profile/" + asDetail.data.store_id)}>
            <SVG name="information" />
          </IconButton>
          {asDetail.isSuccess ? (
            <>
              {asDetail.data.delete_yn !== "Y" && (
                <>
                  {userInfo.user_type === "S" && asDetail.data.progress_value === "20" ? (
                    <IconButton btnName="메뉴더보기" className="more" onClick={openProcessModal}>
                      <SVG name="more" />
                    </IconButton>
                  ) : (
                    <>
                      {userInfo.user_type === "E" && asDetail.data.completionReport_progress !== "ASC_100" ? (
                        <IconButton btnName="메뉴더보기" className="more" onClick={openProcessModal}>
                          <SVG name="more" />
                        </IconButton>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            ""
          )}
        </div>
      </header>

      <Body type="detail">
        {/* 공통 */}
        {asDetail.isSuccess && (
          <>
            {asDetail.data.images.length > 0 ? (
              <ImgSlide>
                <Slider {...settingsNav1}>
                  {asDetail.data.images.map((v: any, i: number) => {
                    return (
                      <div onClick={openImageModal} key={i}>
                        <div className="img-box detail-slide">
                          {v.ext === "mp4" || v.ext === "mov" ? (
                            <VideoBox
                              controls
                              vimeoId={v.img_url}
                              // src={imageServerIp + v.img_url}
                            />
                          ) : (
                            <img src={imageServerIp + v.img_url} alt="더미이미지" />
                          )}
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </ImgSlide>
            ) : (
              ""
            )}
          </>
        )}

        <AsDetailInfo data={asDetail.isSuccess ? asDetail.data : ""} />

        {progressBtn()}

        {/* 공통 댓글 영역 */}
        {asDetail.isSuccess && asDetail.data.comments && (
          <CommentWrap>
            <CommentList>
              <p className="title">댓글 {asDetail.isSuccess && asDetail.data.comments.length > 0 ? asDetail.data.comment_count : ""}</p>
              <List pd="0" itemPd="20px 0">
                <CommentItem onClick={clickCmtImages} />
              </List>
            </CommentList>
            <CommentInputV2 />
          </CommentWrap>
        )}
      </Body>

      <ImageModal ref={imageModalRef}>
        <ModalImgSlide>
          <StyledSlider {...settingsNav2}>
            {asDetail.isSuccess &&
              asDetail.data.images.length > 0 &&
              asDetail.data.images.map((v: any, k: number) => {
                return (
                  <div className="img-box" key={k}>
                    {v.ext === "mp4" || v.ext === "mov" ? (
                      <VideoBox
                        controls
                        playAllow
                        vimeoId={v.img_url}
                        // src={imageServerIp + v.img_url}
                      />
                    ) : (
                      <img src={imageServerIp + v.img_url} alt={v.img_origin_name} />
                    )}
                  </div>
                );
              })}
          </StyledSlider>
        </ModalImgSlide>
      </ImageModal>

      <ImageModal ref={cmtImgModalRef}>
        <ModalImgSlide>
          <StyledSlider ref={(slider: Slider | null) => setImageSlider(slider)} {...settings}>
            {cmtView.cmtType === "parent"
              ? asDetail.isSuccess &&
                asDetail.data.comments.length > 0 &&
                asDetail.data.comments[cmtView.cmtIdx].images.length > 0 &&
                asDetail.data.comments[cmtView.cmtIdx].images.map((v: any, k: number) => {
                  return (
                    <div className="img-box" key={k}>
                      {v.ext === "mp4" || v.ext === "mov" ? (
                        <VideoBox
                          controls
                          playAllow
                          vimeoId={v.img_url}
                          // src={imageServerIp + v.img_url}
                        />
                      ) : (
                        <img src={imageServerIp + v.img_url} alt={v.img_origin_name} />
                      )}
                    </div>
                  );
                })
              : asDetail.isSuccess &&
                asDetail.data.comments.length > 0 &&
                asDetail.data.comments[cmtView.cmtIdx].childComments[cmtView.cmtchildIdx].images.length > 0 &&
                asDetail.data.comments[cmtView.cmtIdx].childComments[cmtView.cmtchildIdx].images.map((v: any, k: number) => {
                  return (
                    <div className="img-box" key={k}>
                      {v.ext === "mp4" || v.ext === "mov" ? (
                        <VideoBox
                          controls
                          playAllow
                          vimeoId={v.img_url}
                          // src={imageServerIp + v.img_url}
                        />
                      ) : (
                        <img src={imageServerIp + v.img_url} alt={v.img_origin_name} />
                      )}
                    </div>
                  );
                })}
          </StyledSlider>
        </ModalImgSlide>
      </ImageModal>

      <Modal ref={stopModalRef} leftBtnText="아니오" rightBtnText="네" onClick2={() => asCancelBtn()}>
        <p>해당 건 접수를 취소하시겠습니까?</p>
      </Modal>

      <BottomModal modalTitle="A/S 관리" ref={processModalRef}>
        <List pd="0 15px">
          <AsProcessItem progressValue={asDetail.isSuccess && asDetail.data.progress_value} onClick={(v: string) => asProcessBtn(v)} />
        </List>
      </BottomModal>

      <Modal ref={deletedModalRef} rightBtnText="확인" onClick2={() => confirmDeleted()}>
        <p>해당 게시글이 삭제되어 확인할 수 없습니다.</p>
      </Modal>
    </>
  );
};

const ImgSlide = styled.div`
  overflow: hidden;
  height: auto;
  background-color: #fff;
`;

const ButtonBox = styled.div`
  padding: 15px;
  background-color: ${({ theme }) => theme.color.bgPrimary};
  ${({ theme }) => theme.flexBox.flexMixin()}
  > button {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

const CommentWrap = styled.div`
  position: relative;
  flex-grow: 1;
`;
const CommentList = styled.div`
  padding: 30px 15px;
  .title {
    font-size: 16px;
    padding-bottom: 15px;
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  }
  ul {
    overflow: hidden;
  }
`;

const NewStore = styled.span`
  margin: -1px 0 0 5px;
  color: ${({ theme }) => theme.color.warning};
  font-family: "Roboto";
  font-size: 18px;
  font-weight: 700;
  vertical-align: middle;
`;

const ModalImgSlide = styled.div`
  height: 100%;
  background: #ccc;
`;

const StyledSlider = styled(Slider)`
  .slick-track {
    height: 100%;
  }
  .slick-slide {
    height: 100%;
    ${({ theme }) => theme.flexBox.flexMixin("column", "center", "center")}
    > div {
      width: 100%;
      height: auto;
      overflow-y: scroll;
    }
    .img-box {
      padding-top: 0;
      text-align: center;
      > img {
        position: initial;
        top: 0;
        left: 0;
        transform: none;
      }
      > .video-wrap {
        position: initial;
        top: 0;
        left: 0;
        transform: none;
      }
    }
  }
  .slick-list {
    background: rgba(0, 0, 0, 0.5);
  }
`;

export default asDetail;
